<template>
    <o-form :title="$t('sandoz.customer_login')"
            :url="'/api/sandoz/customer_logins/' + $route.params.id + '?include=external_ids'"
            class="ortic-form-horizontal mb-4" ref="form">
        <template slot-scope="props">
            <b-row>
                <b-col>
                    <o-input :errorField="'email'" :label="$t('core.email')" v-model="props.item.email"/>
                    <o-input :errorField="'first_name'" :label="$t('core.first_name')" v-model="props.item.first_name"/>
                    <o-input :errorField="'last_name'" :label="$t('core.last_name')" v-model="props.item.last_name"/>
                    <o-form-group :label="$t('core.language')">
                        <b-form-select v-model="props.item.locale" value="props.item.locale" :options="locales" value-field="value" text-field="text"></b-form-select>
                    </o-form-group>
                </b-col>
                <b-col>
                    <o-value-select :label="$t('sandoz.sales_rep')" url="/api/system/users?sortBy=name&filter%5Bactive%5D=1%25" value-field="id" text-field="name" v-model="props.item.sales_rep_id"></o-value-select>
                    <o-input :errorField="'year_from'" :label="$t('sandoz.year_from')" v-model="props.item.year_from" type="number" :step="1"/>
                    <o-input :errorField="'year_to'" :label="$t('sandoz.year_to')" v-model="props.item.year_to" type="number" :step="1"/>
                </b-col>
            </b-row>
        </template>
        <template slot="child" slot-scope="props">
            <b-tabs>
                <b-tab :title="$t('sandoz.external_ids')" active>
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('sandoz.customer_external_id')}}</th>
                                    <th>{{$t('sandoz.status')}}</th>
                                    <th class="text-right">
                                        <b-btn @click.prevent="show()" variant="primary">
                                            <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(external_id, i) in props.item.external_ids" :key="external_id.external_id">
                                    <td>{{external_id.external_id}}</td>
                                    <td>
                                        <label>
                                            <input type="checkbox" :checked="external_id.status == 'active'" @click="external_id.status = external_id.status == 'active' ? 'inactive': 'active'">
                                          {{external_id.status}}
                                        </label>
                                    </td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.external_ids.splice(i, 1)" variant="secondary">
                                                <fa icon="times"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.history')">
                    <o-table ref="tableList" :url="'/api/sandoz/customer_login_history?filter%5Bcustomer_login_id%5D=' + $route.params.id + '%25&include=user'" default-sort-by-direction="desc" default-sort-by="id" :enable-new="false" :enable-edit="false" :enable-delete="false">
                        <template slot="head">
                            <o-table-header column="user_id">{{ $t('sandoz.user') }}</o-table-header>
                            <o-table-header column="created_at">{{ $t('sandoz.date') }}</o-table-header>
                            <o-table-header column="invitation_email">{{ $t('sandoz.invitation_email') }}</o-table-header>
                            <o-table-header column="data">{{ $t('sandoz.data') }}</o-table-header>
                        </template>
                        <template slot="body" slot-scope="props">
                            <td>{{ props.item.user.data.name }}</td>
                            <td>{{ props.item.created_at | formatDate }}</td>
                            <td>{{ props.item.invitation_email ? $t('sandoz.yes') : $t('sandoz.no') }}</td>
                            <td>
                                <span @click="props.item.show_data = !props.item.show_data">...</span>
                                <span v-if="props.item.show_data">{{ props.item.data }}</span>
                            </td>
                        </template>
                    </o-table>
                </b-tab>
            </b-tabs>
            <b-modal id="modal-external-id" ref="addExternalIdModel" :title="$t('sandoz.customer_external_id')"
                     :ok-only="true" size="lg" :ok-title="$t('core.cancel')">
                <o-table url="/api/sandoz/org_contacts?filter%5Bactive_status%5D=Validated%20%26%20Not%20Deleted"
                         title="" ref="externalIdList" :enable-new="false" default-sort-by="external_id"
                         :enable-delete="false" :enable-edit="false" :shadow="false">
                    <template slot="filter">
                        <o-filter v-on:filter-updated="(filters) => $refs.externalIdList.setFilters(filters)">
                            <o-filter-text :title="$t('sandoz.customer_external_id')" column="external_id"
                                           :show-button="true" :prepend-percentage="true">
                            </o-filter-text>
                            <o-filter-text :title="$t('sandoz.full_name')" column="full_name" :show-button="true"
                                           :prepend-percentage="true">
                            </o-filter-text>
                            <o-filter-text :title="$t('sandoz.street')" column="street" :show-button="true"
                                           :prepend-percentage="true">
                            </o-filter-text>
                            <o-filter-text :title="$t('sandoz.zip')" column="zip_code" :show-button="true">
                            </o-filter-text>
                            <o-filter-text :title="$t('sandoz.city')" column="city" :show-button="true">
                            </o-filter-text>
                        </o-filter>
                    </template>
                    <template slot="head">
                        <th>{{$t('sandoz.customer_external_id')}}</th>
                        <th>{{$t('sandoz.full_name')}}</th>
                        <th>{{$t('sandoz.street')}}</th>
                        <th>{{$t('sandoz.zip')}}</th>
                        <th>{{$t('sandoz.city')}}</th>
                    </template>
                    <template slot="body" slot-scope="contactProps">
                        <td>{{ contactProps.item.external_id }}</td>
                        <td>{{ contactProps.item.full_name }}</td>
                        <td>{{ contactProps.item.street }}</td>
                        <td>{{ contactProps.item.zip_code }}</td>
                        <td>{{ contactProps.item.city }}</td>
                    </template>
                    <template slot="body-controls" slot-scope="contactProps">
                        <td class="text-right">
                            <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                                <b-btn variant="primary" @click="addExternalId(contactProps.item.external_id)">
                                  <fa icon="arrow-right"/>
                                </b-btn>
                            </div>
                        </td>
                    </template>
                </o-table>
            </b-modal>
        </template>
        <template slot="footer-buttons-right" slot-scope="props">
            <span class="d-inline-block">
                <b-form-checkbox v-model.lazy="props.item.send_invitation" name="send_invitation" :value="true">
                    {{$t('sandoz.send_invitation')}}
                </b-form-checkbox>
            </span>
        </template>
    </o-form>
</template>

<script>
export default {
    data: () => ({
        locales: []
    }),
    methods: {
        show () {
          this.$refs.addExternalIdModel.show()
        },
        addExternalId (id) {
          this.$refs.form.item.external_ids.push({ external_id: id, status: 'active' })
          this.$refs.addExternalIdModel.hide()
        }
    },
    created() {
        this.locales = [
            {value: 'de', text: 'de'},
            {value: 'fr', text: 'fr'},
            {value: 'it', text: 'it'}
        ]
    }
}
</script>
